import {SportstypeSpec} from "./types";

export type SportPhaseI18nKeyPart = "name"|"short"|"break-name"|"break-short"

export function sportstypeSpecI18nKey(sportstype: SportstypeSpec, key: "name" = "name") {
  return sportI18nKey(sportstype.id, key)
}

export function sportI18nKey(path: string, key: "name"|"placeholder" = "name") {
  return `sports.${path}.${key}`
}

export function sportPhaseI18nKey(id: string, key: SportPhaseI18nKeyPart = "name") {
  return `sport-phases.${id}.${key}`
}

function frenchOrdinal(index: number, gender: "masc"|"fem") {
  if(index !== 1) {
    return `${index}e`
  }
  return gender === "masc" ? "1er" : "1re"
}

// French ordinals are irregular at 1 and gendered, so a catalog cannot build them by
// concatenating a suffix to {{index}} — only the author of an entry knows the gender of
// the noun it qualifies. Both forms are therefore offered as interpolation variables and
// the entry picks one. They are computed for every language but read only by the catalogs
// that reference them, which is what the Fr in the names records.
function sportPhaseI18nOptions(index: number) {
  return {
    index,
    ordinalFrMasc: frenchOrdinal(index, "masc"),
    ordinalFrFem: frenchOrdinal(index, "fem")
  }
}

type SportPhaseTFunction = (key: string, options: ReturnType<typeof sportPhaseI18nOptions>) => string

// The single supported way to resolve a repeating phase label: a write path that builds
// the interpolation object by hand would store a label with an unreplaced placeholder.
export function tSportPhase(t: SportPhaseTFunction, id: string, key: SportPhaseI18nKeyPart, index: number) {
  return t(sportPhaseI18nKey(id, key), sportPhaseI18nOptions(index))
}
